import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import { ProductIndexing } from './models';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.productIndexingList = [];
};

const productIndexingListSuccess = (state, productIndexingList) => {
  state.productIndexingList = productIndexingList;
};

const createProductIndexingSuccess = (state, productIndexing) => {
  let existingIndexing = state.productIndexingList.find((indexing) => indexing.referenceProductGuid === productIndexing.referenceProductGuid);
  if (!existingIndexing) {
    existingIndexing = new ProductIndexing(productIndexing.referenceProductGuid);
    state.productIndexingList.push(existingIndexing);
  }
  existingIndexing.addAssociatedProduct(
    productIndexing.guid,
    productIndexing.associatedProductGuid,
    productIndexing.ratio
  );
  state.productIndexingList = [...state.productIndexingList];
};

const removeProductIndexingSuccess = (state, { referenceProductGuid, productIndexingGuid }) => {
  const existingIndexingIndex = state.productIndexingList.findIndex((indexing) => indexing.referenceProductGuid === referenceProductGuid);
  const existingIndexing = state.productIndexingList[existingIndexingIndex];
  existingIndexing.removeAssociatedProduct(productIndexingGuid);
  if (existingIndexing.associatedProducts.length === 0) {
    state.productIndexingList.splice(existingIndexingIndex, 1);
  }
  state.productIndexingList = [...state.productIndexingList];
};

const editProductIndexingSuccess = (state, { referenceProductGuid, associatedProductGuid, ratio }) => {
  const existingIndexing = state.productIndexingList.find((indexing) => indexing.referenceProductGuid === referenceProductGuid);
  existingIndexing.editRatio(associatedProductGuid, ratio);
  state.productIndexingList = [...state.productIndexingList];
};

export const mutations = {
  [MutationTypes.PRODUCT_INDEXING_LIST_SUCCESS]: productIndexingListSuccess,
  [MutationTypes.CREATE_PRODUCT_INDEXING_SUCCESS]: createProductIndexingSuccess,
  [MutationTypes.REMOVE_PRODUCT_INDEXING_SUCCESS]: removeProductIndexingSuccess,
  [MutationTypes.EDIT_PRODUCT_INDEXING_SUCCESS]: editProductIndexingSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
